import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../../Component/Layouts/App/Candidates/StudentApp/Icon';
import { WEB_BASE } from '../../../../Component/Layouts/Web/Student/WebLayout';
import '../../../../Component/Layouts/Web/Student/WebLayout.css';

const Login = () => {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState('');

  const continueIn = (event) => {
    event.preventDefault();
    if (mobile.trim().length < 10) return;
    navigate(WEB_BASE);
  };

  return (
    <div className="web-login">
      <form onSubmit={continueIn}>
        <button type="button" className="web-brand">
          <Icon name="logo" />
          Focalyt
        </button>
        <h1>Welcome back</h1>
        <p className="web-mut">Sign in on the web to continue your courses, jobs, clubs and achievements.</p>
        <label htmlFor="web-student-mobile" style={{ display: 'block', fontWeight: 800, margin: '18px 0 6px' }}>Mobile number</label>
        <input
          id="web-student-mobile"
          className="web-field"
          inputMode="numeric"
          autoComplete="tel"
          maxLength={10}
          placeholder="10-digit mobile number"
          value={mobile}
          onChange={(event) => setMobile(event.target.value.replace(/\D/g, '').slice(0, 10))}
        />
        <button type="submit" className="web-btn" style={{ marginTop: 16 }} disabled={mobile.length < 10}>
          Continue
        </button>
      </form>
    </div>
  );
};

export default Login;
